<template>
  <transition v-cloak name="modal">
    <v-modal :is-open="showQuickQuoteModalIE" @close="close">
      <template #title>
        <h2>
          {{ title }}
        </h2>
      </template>
      <template #content>
        <p v-html="text" />
      </template>
      <template #buttons>
        <button class="button large" @click="close">
          {{ buttonText }}
        </button>
      </template>
    </v-modal>
  </transition>
</template>

<script>
import vModal from '@/components/UI/Modal.vue';

export default {
  name: 'InternetExplorerNotification',

  props: {
    title: {
      type: String,
      default() {
        return '';
      }
    },
    text: {
      type: String,
      default() {
        return '';
      }
    },
    buttonText: {
      type: String,
      default() {
        return '';
      }
    }
  },
  data() {
    return {
      showQuickQuoteModalIE: false
    };
  },
  mounted() {
    // document.cookie = 'esben=pernille';
    const ieDetected = this.detectIE() !== false && this.detectIE() < 12;

    if (
      ieDetected &&
      document.cookie.replace(
        /(?:(?:^|.*;\s*)internetExplorerDetected\s*=\s*([^;]*).*$)|^.*$/,
        '$1'
      ) !== 'true'
    ) {
      this.showQuickQuoteModalIE = true;
    }
  },
  methods: {
    close() {
      this.showQuickQuoteModalIE = false;
      document.cookie = 'internetExplorerDetected=true';
    },
    detectIE() {
      const ua = window.navigator.userAgent;
      const msie = ua.indexOf('MSIE ');
      if (msie > 0) {
        // IE 10 or older => return version number
        return parseInt(ua.substring(msie + 5, ua.indexOf('.', msie)), 10);
      }

      const trident = ua.indexOf('Trident/');
      if (trident > 0) {
        // IE 11 => return version number
        const rv = ua.indexOf('rv:');
        return parseInt(ua.substring(rv + 3, ua.indexOf('.', rv)), 10);
      }

      const edge = ua.indexOf('Edge/');
      if (edge > 0) {
        // Edge (IE 12+) => return version number
        return parseInt(ua.substring(edge + 5, ua.indexOf('.', edge)), 10);
      }

      // other browser
      return false;
    }
  }
};
</script>
